module.exports = __webpack_public_path__ + "resources/img/img_cloud_moa2.b6ac38de4aefb486cc6d269ae2e38a5b.png";